function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
var DemantBoxSpot = /*#__PURE__*/function (_WDHComponent) {
  function DemantBoxSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'box-spot';
    _classCallCheck(this, DemantBoxSpot);
    return _callSuper(this, DemantBoxSpot, [className]);
  }
  _inherits(DemantBoxSpot, _WDHComponent);
  return _createClass(DemantBoxSpot, [{
    key: "renderItem",
    value: function renderItem(element) {
      var imageSrc = element.style.backgroundImage;
      if (imageSrc) imageSrc = imageSrc.replace('url("', '').replace('")', '');
      var text = element.innerHTML;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "box-spot-item-image"
      }, /*#__PURE__*/React.createElement("img", {
        src: imageSrc,
        alt: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "box-spot-item-text",
        dangerouslySetInnerHTML: {
          __html: text
        }
      }));
    }
  }, {
    key: "init",
    value: function init(component) {
      var _this = this;
      var boxSpotElements = Array.prototype.slice.call(component.querySelectorAll('.box-spot-item'));
      ReactDOM.render(/*#__PURE__*/React.createElement(React.Fragment, null, boxSpotElements.map(function (element, index) {
        var link = element.dataset.link;
        link = link || 'http://www.google.com';
        return /*#__PURE__*/React.createElement(React.Fragment, null, link && /*#__PURE__*/React.createElement("a", {
          className: "box-spot-item-outer",
          href: link
        }, /*#__PURE__*/React.createElement("div", {
          key: "box-spot-item-".concat(index),
          className: "box-spot-item"
        }, _this.renderItem(element))), !link && /*#__PURE__*/React.createElement("div", {
          className: "box-spot-item-outer"
        }, /*#__PURE__*/React.createElement("div", {
          key: "box-spot-item-".concat(index),
          className: "box-spot-item"
        }, _this.renderItem(element))));
      })), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
new DemantBoxSpot().run();